/**
 * ScreenCheck Portal API
 * ScreenCheck Portal REST API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The MachineBasefile model module.
 * @module model/MachineBasefile
 * @version 0.0.1
 */
class MachineBasefile {
    /**
     * Constructs a new <code>MachineBasefile</code>.
     * @alias module:model/MachineBasefile
     */
    constructor() { 
        
        MachineBasefile.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>MachineBasefile</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/MachineBasefile} obj Optional instance to populate.
     * @return {module:model/MachineBasefile} The populated <code>MachineBasefile</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new MachineBasefile();

            if (data.hasOwnProperty('coverimage')) {
                obj['coverimage'] = ApiClient.convertToType(data['coverimage'], 'String');
            }
            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('lat')) {
                obj['lat'] = ApiClient.convertToType(data['lat'], 'Number');
            }
            if (data.hasOwnProperty('lon')) {
                obj['lon'] = ApiClient.convertToType(data['lon'], 'Number');
            }
            if (data.hasOwnProperty('owner')) {
                obj['owner'] = ApiClient.convertToType(data['owner'], 'String');
            }
            if (data.hasOwnProperty('serial')) {
                obj['serial'] = ApiClient.convertToType(data['serial'], 'String');
            }
            if (data.hasOwnProperty('type')) {
                obj['type'] = ApiClient.convertToType(data['type'], 'String');
            }
            if (data.hasOwnProperty('machine_file_revision')) {
                obj['machine_file_revision'] = ApiClient.convertToType(data['machine_file_revision'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>MachineBasefile</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>MachineBasefile</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['coverimage'] && !(typeof data['coverimage'] === 'string' || data['coverimage'] instanceof String)) {
            throw new Error("Expected the field `coverimage` to be a primitive type in the JSON string but got " + data['coverimage']);
        }
        // ensure the json data is a string
        if (data['owner'] && !(typeof data['owner'] === 'string' || data['owner'] instanceof String)) {
            throw new Error("Expected the field `owner` to be a primitive type in the JSON string but got " + data['owner']);
        }
        // ensure the json data is a string
        if (data['serial'] && !(typeof data['serial'] === 'string' || data['serial'] instanceof String)) {
            throw new Error("Expected the field `serial` to be a primitive type in the JSON string but got " + data['serial']);
        }
        // ensure the json data is a string
        if (data['type'] && !(typeof data['type'] === 'string' || data['type'] instanceof String)) {
            throw new Error("Expected the field `type` to be a primitive type in the JSON string but got " + data['type']);
        }

        return true;
    }


}



/**
 * @member {String} coverimage
 */
MachineBasefile.prototype['coverimage'] = undefined;

/**
 * @member {Number} id
 */
MachineBasefile.prototype['id'] = undefined;

/**
 * @member {Number} lat
 */
MachineBasefile.prototype['lat'] = undefined;

/**
 * @member {Number} lon
 */
MachineBasefile.prototype['lon'] = undefined;

/**
 * @member {String} owner
 */
MachineBasefile.prototype['owner'] = undefined;

/**
 * @member {String} serial
 */
MachineBasefile.prototype['serial'] = undefined;

/**
 * @member {String} type
 */
MachineBasefile.prototype['type'] = undefined;

/**
 * @member {Number} machine_file_revision
 */
MachineBasefile.prototype['machine_file_revision'] = undefined;






export default MachineBasefile;

